// SPEC-55 · the laterality question in the screen's language: FR or EN from
// src/i18n/laterality.*.ts, PT from poweryourflow-lib, which is also what a
// missing word falls back to. Her own typed words show as typed.

import { lateralityQuestion } from "poweryourflow-lib";

import { useLanguage } from "../i18n/LanguageProvider";
import type { LateralityDictionary } from "../i18n/laterality";
import { LATERALITY_EN } from "../i18n/laterality.en";
import { LATERALITY_FR } from "../i18n/laterality.fr";
import type { Language, Laterality, LateralityKind } from "../schema/types";

const DICTIONARIES: Readonly<Record<Language, LateralityDictionary>> = { pt: {}, fr: LATERALITY_FR, en: LATERALITY_EN };

export interface LateralityWords {
  /** Lena's question for this kind: « Com que pé rematas? ». */
  question(kind: LateralityKind): string;
  /** The admin's label for this kind: « Pé dominante ». */
  label(kind: LateralityKind): string;
  /** One answer's words. */
  option(kind: LateralityKind, optionId: string): string;
  /** A stored answer: an option's words, or what she typed. */
  answer(laterality: Laterality): string;
}

export function lateralityWords(language: Language): LateralityWords {
  const words = DICTIONARIES[language];
  const option = (kind: LateralityKind, optionId: string): string | undefined =>
    words[kind]?.options?.[optionId] ?? lateralityQuestion(kind).options.find((candidate) => candidate.id === optionId)?.label;
  return {
    question: (kind) => words[kind]?.question ?? lateralityQuestion(kind).question,
    label: (kind) => words[kind]?.label ?? lateralityQuestion(kind).label,
    option: (kind, optionId) => option(kind, optionId) ?? optionId,
    answer: ({ kind, value }) => option(kind, value) ?? value,
  };
}

/** The laterality question's words in the current language, read at render. */
export const useLateralityWords = (): LateralityWords => lateralityWords(useLanguage().language);
